exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.document-popup{height:750px;width:520px;max-height:calc(100vh - 116px);overflow-y:auto;position:fixed;top:100px;left:calc(50vw - 260px);background:#fff;border-radius:8px;transition:opacity .3s ease;opacity:1;z-index:25}.document-popup--closing{opacity:0}.document-popup__close-button{cursor:pointer;position:absolute;top:5px;right:16px;height:16px;width:14px;font-size:28px;color:#9b9b9b}.document-popup .attachment-display .display-container{height:487px;width:458px;border:1px solid #979797;box-sizing:border-box}.document-popup .attachment-display .display-container .no-documents-icon{margin-left:16%}.document-popup .attachment-display .display-container object{height:100%}.document-popup .attachment-display .comment-list-container{min-height:unset}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/DocumentPopup/DocumentPopup.scss
// module id = 1553
// module chunks = 0